import isEqual from 'lodash/isEqual';
import { useState, useCallback } from 'react';
// @mui
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// _mock
import { _userList } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {
    useTable,
    getComparator
} from 'src/components/table';
import { Box, Grid } from '@mui/material';
import VendorComp from './vendor-user-list-comp';
import Iconify from 'src/components/iconify';


// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'name', label: 'Code ' },
    { id: 'name', label: 'Description' },
    { id: 'name', label: 'Quanitity' },
    { id: 'name', label: 'Labour hours' },
    { id: 'name', label: 'Labour Cost' },
    { id: 'name', label: 'Material Cost' },
    { id: 'name', label: 'Equipment Cost' },
    { id: 'name', label: 'Subcontractor Cost' },
    { id: 'name', label: 'Other Cost' },
    { id: 'name', label: 'Total Direct Cost' },
    { id: 'name', label: 'Direct Unit Price' },
    { id: 'name', label: 'Markup %' },
    { id: 'name', label: 'Markup Up/ Bid Amount' },
    { id: 'name', label: 'Markup Up/ Bid Unit Price ' },
    { id: 'role', label: 'Start Date', width: 180 },
    { id: 'role', label: 'Finish Date', width: 180 },
    { id: 'role', label: 'Duration', width: 180 },
    { id: 'status', label: 'Action', width: 100 },
    { id: '', width: 88 },
];

const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
};
// ----------------------------------------------------------------------

export default function VendorUserShowPage({ currentItem }) {
    const table = useTable();
    const settings = useSettingsContext();
    const router = useRouter();
    const confirm = useBoolean();

    const [ tableData, setTableData ] = useState(_userList);
    const [ filters, setFilters ] = useState(defaultFilters);

    const dataFiltered = applyFilter({
        inputData: tableData,
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });

    const dataInPage = dataFiltered.slice(
        table.page * table.rowsPerPage,
        table.page * table.rowsPerPage + table.rowsPerPage
    );

    const denseHeight = table.dense ? 52 : 72;
    const canReset = !isEqual(defaultFilters, filters);
    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

    const handleFilters = useCallback(
        (name, value) => {
            table.onResetPage();
            setFilters((prevState) => ({
                ...prevState,
                [ name ]: value,
            }));
        },
        [ table ]
    );

    const handleDeleteRow = useCallback(
        (id) => {
            const deleteRow = tableData.filter((row) => row.id !== id);
            setTableData(deleteRow);

            table.onUpdatePageDeleteRow(dataInPage.length);
        },
        [ dataInPage.length, table, tableData ]
    );

    const handleDeleteRows = useCallback(() => {
        const deleteRows = tableData.filter((row) => !table.selected.includes(row.id));
        setTableData(deleteRows);

        table.onUpdatePageDeleteRows({
            totalRows: tableData.length,
            totalRowsInPage: dataInPage.length,
            totalRowsFiltered: dataFiltered.length,
        });
    }, [ dataFiltered.length, dataInPage.length, table, tableData ]);

    const handleEditRow = useCallback(
        (id) => {
            router.push(paths.dashboard.user.edit(id));
        },
        [ router ]
    );

    const handleFilterStatus = useCallback(
        (event, newValue) => {
            handleFilters('status', newValue);
        },
        [ handleFilters ]
    );

    const handleResetFilters = useCallback(() => {
        setFilters(defaultFilters);
    }, []);

    const userDetails = [
        { label: 'First Name', value: currentItem?.label1 || 'N/A' },
        { label: 'Last Name', value: currentItem?.label2 || 'N/A' },
        { label: 'Email Adress', value: currentItem?.label3 || 'N/A' },
        { label: 'Mobile Number', value: currentItem?.label4 || 'N/A' },
        { label: 'Avatar', value: currentItem?.label5 || 'N/A' },
        { label: 'Signature', value: currentItem?.label6 || 'N/A' },
    ];

    const companyDetails = [
        { label: 'Company Name', value: currentItem?.label1 || 'N/A' },
        { label: 'Email (if applicable)', value: currentItem?.label3 || 'N/A' },
        { label: 'Phone Number', value: currentItem?.label4 || 'N/A' },
        { label: 'Office Phone Number', value: currentItem?.label4 || 'N/A' },
        { label: 'Fax', value: currentItem?.label2 || 'N/A' },
        { label: 'Office Adress Line 1', value: currentItem?.label2 || 'N/A' },
        { label: 'Office Adress Line 2', value: currentItem?.label2 || 'N/A' },
        { label: 'Suite (if applicable)', value: currentItem?.label3 || 'N/A' },
        { label: 'Country', value: currentItem?.label3 || 'N/A' },
        { label: 'State', value: currentItem?.label3 || 'N/A' },
        { label: 'City', value: currentItem?.label3 || 'N/A' },
        { label: 'Zip Code ', value: currentItem?.label3 || 'N/A' },
        { label: 'Avatar', value: currentItem?.label5 || 'N/A' },
        { label: 'Tax ID', value: currentItem?.label6 || 'N/A' },
    ];
    const addDetails = [
        { label: 'Company Website', value: currentItem?.label1 || 'N/A' },
        { label: 'Services Area', value: currentItem?.label3 || 'N/A' },
        { label: 'Company Type', value: currentItem?.label4 || 'N/A' },
        { label: 'Trades', value: currentItem?.label4 || 'N/A' },
        { label: 'Industries', value: currentItem?.label2 || 'N/A' },
        { label: 'SIC_CODE', value: currentItem?.label2 || 'N/A' },
        { label: 'Contract Size', value: currentItem?.label3 || 'N/A' },
        { label: 'Company Size', value: currentItem?.label3 || 'N/A' },
        { label: 'Bussiness Classification', value: currentItem?.label3 || 'N/A' },
        { label: 'In Bussiness Since', value: currentItem?.label3 || 'N/A' },
    ];


    return (
        <>
            <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
                <CustomBreadcrumbs
                    heading="Vendors List"
                    links={ [
                        { name: '', href: paths.dashboard.root },

                    ] }
                    action={
                        <>
                            <Button
                                // component={ RouterLink }
                                style={ { marginRight: '10px' } }
                                href={ paths.dashboard.product_user_offers_create }
                                variant="contained"
                                startIcon={ <Iconify icon="mingcute:add-line" /> }
                            >
                                Unpublish the vendor Profile
                            </Button>
                            <Button

                                // component={ RouterLink }
                                href={ paths.dashboard.product_user_offers_create }
                                variant="contained"
                                startIcon={ <Iconify icon="mingcute:add-line" /> }
                            >
                                Bank to Page
                            </Button>
                        </>
                    }
                    sx={ {
                        mb: { xs: 3, md: 5, },
                    } }
                />

                <VendorComp userDetails={ userDetails } heading={ "User Information" } />
                <VendorComp userDetails={ companyDetails } heading={ "Company Information" } />
                <VendorComp userDetails={ addDetails } heading={ "Additional Information" } />


            </Container>
            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content={
                    <>
                        Are you sure want to delete <strong> { table.selected.length } </strong> items?
                    </>
                }
                action={
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ () => {
                            handleDeleteRows();
                            confirm.onFalse();
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}

// ----------------------------------------------------------------------
function applyFilter({ inputData, comparator, filters }) {
    const { name, status, role } = filters;

    const stabilizedThis = inputData.map((el, index) => [ el, index ]);

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[ 0 ], b[ 0 ]);
        if (order !== 0) return order;
        return a[ 1 ] - b[ 1 ];
    });

    inputData = stabilizedThis.map((el) => el[ 0 ]);

    if (name) {
        inputData = inputData.filter(
            (user) => user.name.toLowerCase().indexOf(name.toLowerCase()) !== -1
        );
    }

    if (status !== 'all') {
        inputData = inputData.filter((user) => user.status === status);
    }

    if (role.length) {
        inputData = inputData.filter((user) => role.includes(user.role));
    }

    return inputData;
}
